import Web3 from 'web3'

let getWeb3 = new Promise(function (resolve, reject) {
  window.addEventListener('load', async () => {
    var results
    // Modern dapp browsers...
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum);
      try {
        // Request account access if needed
        await window.ethereum.enable();
        // Acccounts now exposed
        results = {
          web3: window.web3
        }
        console.log('Injected web3 detected.');

        resolve(results)
        // web3.eth.sendTransaction({/* ... */});
      } catch (error) {
        // User denied account access...
        results = {
          web3: null
        }
        resolve(results)
      }
    }
    // Legacy dapp browsers...
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
      // Acccounts always exposed
      // web3.eth.sendTransaction({/* ... */});
      results = {
        web3: window.web3
      }
      console.log('Injected web3 detected.');

      resolve(results)
    }
    // Non-dapp browsers...
    else {
      console.log('Non-Ethereum browser detected. You should consider trying MetaMask!');
      results = {
        web3: null
      }
      resolve(results)
    }
  })
})
  //   // Wait for loading completion to avoid race conditions with web3 injection timing.
  //   window.addEventListener('load', function () {
  //     var results
  //     var web3 = window.web3

  //     // Checking if Web3 has been injected by the browser (Mist/MetaMask)
  //     if (typeof web3 !== 'undefined') {
  //       // Use Mist/MetaMask's provider.
  //       web3 = new Web3(web3.currentProvider)

  //       results = {
  //         web3: web3
  //       }
  //       console.log('Injected web3 detected.');

  //       resolve(results)
  //     } else {
  //       results = {
  //         web3: null
  //       }
  //       resolve(results)
  //     }
  //   })
  // })

  export default getWeb3



// WEBPACK FOOTER //
// ./src/utils/getWeb3.js